import { CHART_COLORS } from "../../../constants/chartColors";
import { formatCurrency } from '@/utils/formatters';

interface ClientLegendProps {
  data: { name: string; value: number; }[];
}

export const ClientLegend = ({ data }: ClientLegendProps) => {
  return (
    <div className="space-y-4">
      {data.map((client, index) => (
        <div key={index} className="flex justify-between items-center">
          <div className="flex items-center">
            <div 
              className="w-3 h-3 rounded-full mr-2"
              style={{ backgroundColor: CHART_COLORS.primary[index % CHART_COLORS.primary.length] }}
            />
            <span className="text-sm font-medium truncate max-w-[150px]">
              {client.name}
            </span>
          </div>
          <span className="text-sm font-mono">
            {formatCurrency(client.value)}
          </span>
        </div>
      ))}
    </div>
  );
};
